/* eslint-disable */
import api from '@/services/api';
import mime from 'mime-types';
import Vue from 'vue';
import Vuetify from '@/plugins/vuetify';

export default {
  async baixarDocumentos(_, payload) {
    try {
      const params = new URLSearchParams();

      if (typeof payload !== 'string' && payload.length) {
        payload.forEach(({ hash }) => {
          params.append('hash', hash);
        });
      } else {
        params.append('hash', payload);
      }

      const response = await api.get('/processoArquivos/arquivos/baixar', { params, responseType: 'arraybuffer' });

      const nomeArquivo = response.headers['content-disposition'].split('\"')[1];

      const blob = new Blob([response.data]);

      const link = document.createElement('a');

      link.href = URL.createObjectURL(blob);
      link.download = nomeArquivo;

      link.click();

      Vue.$toast.success(
        Vuetify.framework.lang.t('$vuetify.documentoBaixadoSucesso')
      );
    } catch(e) {
      Vue.$toast.clear();
      Vue.$toast.error(
        Vuetify.framework.lang.t('$vuetify.erroBaixarDocumento')
    )}
  },
  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },
  async visualizarDocumento(_, payload) {
    try {
      const params = new URLSearchParams();

      params.append('hash', payload);

      const response = await api.get('/processoArquivos/arquivos/baixar', { params, responseType: 'arraybuffer' });

      // transformar nome do arquivo e pegar somente a extensão para obter o mimetype
      // com o mimetype correto, ele consegue criar o objeto e visualizar corretamente
      const nomeArquivo = response.headers['content-disposition'].split('\"')[1];
      const extensaoArquivo = nomeArquivo.match(/\.([^.]+)$/)[1];

      const type = mime.lookup(extensaoArquivo);

      const blob = new Blob([response.data], { type });

      const url = window.URL.createObjectURL(blob);

      window.open(url);
      window.URL.revokeObjectURL(url);
    } catch(e) {
      Vue.$toast.clear();
      Vue.$toast.error(
        Vuetify.framework.lang.t('$vuetify.erroVisualizarDocumento')
    )}
  },
};
